var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-5"},[_c('h2',{staticClass:"co-title mb-3"},[_vm._v("Templates")]),_c('sop-template-selection',{staticClass:"mb-3"}),_c('sop-used-templates')],1)}
var staticRenderFns = []

export { render, staticRenderFns }